module.exports = __webpack_public_path__ + "static/media/inquiry_history_current.475d688f.svg";